import { createAction, handleActions } from 'redux-actions';

const setSubmitting = createAction("MODALS/SUPPLIER/SET_SUBMITTING");

const defaultState = false;

const reducer = handleActions(
  {
    [setSubmitting]: (state, action) => action.payload
  },
  defaultState
);

export { setSubmitting, reducer };
